import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {DASHBOARD_ROUTES} from './DashboardRoutes';
import {buildRoute} from '../navigationUtils';
import './DashboardNavigationSideBar.css';
import {useHistory} from 'react-router-dom';
import {SidebarAdvertisementComponent} from './SidebarAdvertisement';
import {getPulsoidSetupConfiguration} from '../../../setupSteps/getPulsoidSetupConfiguration';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {BroPlanSideBarButton} from './broplan/BroPlanSideBarButton';

export const DashboardNavigationSideBar = ({hasReport}) => {
  const [numberOfCompletedSteps, setNumberOfCompletedSteps] = useState(6);
  const [totalStepsCount, setTotalStepsCount] = useState(6);

  useEffect(() => {
    async function fetchSetupConfiguration() {
      const setupConfig = await getPulsoidSetupConfiguration();
      setNumberOfCompletedSteps(setupConfig.completedStepsCount);
      setTotalStepsCount(setupConfig.totalStepsCount);
    }
    fetchSetupConfiguration();
  }, []);

  return (
    <div className="dashboard-navigation-side-bar">
      {hasReport && (
        <SideBarEntry
          to={buildRoute({path: DASHBOARD_ROUTES.YEARLY_REPORT})}
          icon={<FontAwesomeIcon icon={faStar} color={'#04bbaf'} />}
          name="YEARLY REPORT"
        />
      )}

      {numberOfCompletedSteps !== totalStepsCount && (
        <Link
          className="setup-pulsoid-side-bar-entry"
          to={buildRoute({path: DASHBOARD_ROUTES.WELCOME})}
        >
          <span>Setup Pulsoid</span>
          <div className="progress-bar-setup-pulsoid">
            <span
              className="progress-bar-setup-pulsoid-fill"
              style={{
                width: (numberOfCompletedSteps / totalStepsCount) * 100 + '%',
              }}
            ></span>
          </div>
          <span
            style={{
              opacity: 0.5,
              fontSize: '0.8rem',
            }}
          >
            {numberOfCompletedSteps}/{totalStepsCount} completed
          </span>
        </Link>
      )}

      <BroPlanSideBarButton />

      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.DASHBOARD})}
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="4" fill="#71717A" />
            <path
              d="M7.19922 17.6V10L11.9992 6.4L16.7992 10V17.6H13.1992V13.2H10.7992V17.6H7.19922Z"
              fill="white"
            />
          </svg>
        }
        name="Dashboard"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.CONFIGURATION})}
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="4" fill="#E73B2E" />
            <path
              d="M14.6652 6.4C15.7319 6.4 16.6236 6.79733 17.3404 7.592C18.0572 8.38613 18.4156 9.32773 18.4156 10.4168C18.4156 10.5832 18.4044 10.7499 18.382 10.9168C18.3602 11.0832 18.3324 11.2443 18.2988 11.4H14.3156L13.2988 10H12.2484L11.1324 12.5168L10.3156 11.4H5.69883C5.65456 11.2443 5.6239 11.0832 5.60683 10.9168C5.5903 10.7499 5.58203 10.5832 5.58203 10.4168C5.58203 9.32773 5.94043 8.38613 6.65723 7.592C7.37403 6.79733 8.26576 6.4 9.33243 6.4C9.84336 6.4 10.3266 6.5056 10.782 6.7168C11.2375 6.928 11.6431 7.2168 11.9988 7.5832C12.3434 7.2056 12.746 6.91387 13.2068 6.708C13.6682 6.50267 14.1543 6.4 14.6652 6.4ZM12.0156 18.1L6.71563 13.1832C6.61536 13.0941 6.5263 13.0024 6.44843 12.908C6.3711 12.8136 6.2935 12.7109 6.21563 12.6H9.68203L10.6988 14H11.7492L12.8652 11.5L13.6652 12.6H17.782C17.7154 12.7003 17.6431 12.7976 17.5652 12.892C17.4874 12.9864 17.4042 13.0779 17.3156 13.1664L12.0156 18.1Z"
              fill="white"
            />
          </svg>
        }
        name="Widgets"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.INTEGRATIONS})}
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="4" fill="#FDB008" />
            <path
              d="M9.54169 16.1275L5.41016 12L9.54169 7.86848L10.5232 8.84602L7.37321 11.996L10.5232 15.146L9.54169 16.1275ZM14.4613 16.1315L13.4797 15.154L16.6297 12.004L13.4797 8.85398L14.4613 7.87247L18.5928 12L14.4613 16.1315Z"
              fill="#3D3012"
            />
          </svg>
        }
        name="Integrations"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.REPORTS})}
        icon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="24" rx="4" fill="#07ABA1" />
            <path
              d="M7.19922 16.8V10.4H9.59922V16.8H7.19922ZM10.7992 16.8V7.2H13.1992V16.8H10.7992ZM14.3992 16.8V12H16.7992V16.8H14.3992Z"
              fill="white"
            />
          </svg>
        }
        name="Reports"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.MIDI})}
        icon={
          <img
            src="https://assets.vrchat.com/www/favicons/favicon.ico"
            height={24}
            width={24}
          />
        }
        name="VRChat Worlds"
      />
      <div style={{border: '1px solid #2C2C33'}} />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.EXPORT})}
        name="Export"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.KEYS})}
        name="Tokens"
      />
      <SideBarEntry
        to={buildRoute({path: DASHBOARD_ROUTES.DASHBOARD, hash: 'referral'})}
        name="Referral program"
      />

      <SidebarAdvertisementComponent />
      {/* <div>
        <img
          src="https://placehold.co/600x400"
          alt="Pulsoid"
          style={{width: '100%', height: '100%', borderRadius: '3px'}}
        />
      </div> */}
    </div>
  );
};

const SideBarEntry = ({to, icon, name, iconColor, isNew = false}) => {
  const history = useHistory();

  return (
    <Link to={to} className="side-bar-entry">
      {icon}
      <span style={{fontSize: '1rem'}}>{name}</span>
    </Link>
  );
};
